<template>
    <div class="grcform" style="padding-left:10px; padding-right:10px;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>

    <div class="grc_fullwidth_lane">
      <div class="grc_maincont_lane" style="padding-bottom: 20px;">
          <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
              <span class="line color1">
                <span class="title_general" style="padding-left:10px !important;">
                  {{txtTitle}}
                  </span>
              </span>
          </div>

          <div class="ik_infotext" style="text-align:center;" v-html="text1" v-show="text1!=''" />

            <div style="width:100%; box-sizing:border-box; max-width:600px; margin:0px auto; display:block;">
                <GrcText ref="txtEmailCim" v-model="txtEmailCim" 
                grc_labeltext="E-mail cím:"
                grc_placeholder="..."
                grc_labelmode="" grc_labelwidth="100px" 
                style="margin-bottom:20px;"
                />
            </div>



          <div class="ik_infotext" v-html="text2" v-show="text2!=''" />


        <div class="btncont">

            <GrcButton ref="btnMentes" grc_text="Mentés" @grc-click="btnMentes_click" grc_readonly="false" 
            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="130px"
            grc_buttonpos="left"
            grc_textalign="center"
            grc_lefticon="<i class='fas fa-check'></i>"
            style="display:inline-block;" />                    

            <GrcButton ref="btnMegsem" grc_text="Mégsem" @grc-click="btnMegsem_click" grc_readonly="false" 
            grc_color="yellow" grc_shadow="false" grc_radius="2px" grc_width="130px"
            grc_buttonpos="left"
            grc_textalign="center"
            grc_lefticon="<i class='fas fa-times'></i>"
            style="display:inline-block; margin-left:50px;" />        
        </div>


      </div>
    </div>
    </div>
</template>

<script>


import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcText from '../GrcComponents/GrcText.vue'


export default {
  name: 'frmIratkuldoSzolgaltatas',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcText,
  },
  props: {
  },
  data () {
      return {
        txtTitle: "",
        text1:"",
        text2:"",
        txtEmailCim:"",

        RefNum: "",
      }
  },
  model: {
  },  
  methods:{

      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },


    async btnMentes_click()
    {
        var ErrorCompName = "";
        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }



        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sRefNum: this.RefNum,
            sEmailCim: this.$refs.txtEmailCim.GetText(),
        };
        var Q;
        await this.$refs.GRCDB.GetData("IratkuldoSzolgaltatas_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            //alert(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult("Az adatok mentése sikeresen megtörtént!",150);

        document.location = "https://premiumegeszsegpenztar.hu";


    },

    async btnMegsem_click()
    {
        document.location = "https://premiumegeszsegpenztar.hu";
    },


    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmIratkuldoSzolgaltatas", pCompName);
    },

    SetLang()
    {
        this.txtTitle = this.GetTextBookItem("title");
        this.text1 = this.GetTextBookItem("text1");
        this.text2 = this.GetTextBookItem("text2");


        this.Init();
    },

    HandleCommError(pErrorText)
    {
    this.$emit("handlecommerror", pErrorText);
    },

    async Init()
    {
        if ((GRCAPP_GetParameters.PC_REFNUM != "") && (GRCAPP_GetParameters.PC_REFNUM != undefined))
        {
            this.RefNum = GRCAPP_GetParameters.PC_REFNUM;
            GRCAPP_GetParameters.PC_REFNUM = "";
        }

        this.scrollToTop();

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sRefNum: this.RefNum
        };
        var Q;
        await this.$refs.GRCDB.GetData("IratkuldoSzolgaltatas_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            //alert(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);


        this.$refs.GRCDB.HideLoading();
    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },
  created()
  {
    
  },
  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>


.ik_infotext
{
    width:100%;
    box-sizing: border-box;
    display:block;

    font-size: 16px;
    line-height: 24px;
    font-family: 'PremiumDefault';
    font-weight: normal;
    text-align: justify;
    padding: 4px 0px;
    margin-bottom: 20px;
}

.btncont
{
    width:100%;
    box-sizing: border-box;
    display:block;
    text-align: center;
}


@media (max-width:600px)
{


}

</style>